import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import { Brightness4 as IconDark, Brightness7 as IconLigth, BrightnessAuto as IconAuto } from '@material-ui/icons';

import { LIGHT_MODE, THEMES, TIPO_DOCUMENTO } from '~/constants';
import * as appActions from '~/store/modules/app/app-actions';
import useSettings from '~/hooks/useSettings';

const ChangeTheme = () => {
  // const { theme } = useSelector(state => state.app);
  const { settings, saveSettings } = useSettings();

  const dispatch = useDispatch();
  return (
    <Tooltip title="Alterar tema claro/escuro">
      <IconButton
        style={{ marginLeft: 8 }}
        onClick={() => {
          let newSettings = {}
          switch (settings.lightMode) {
            case LIGHT_MODE.AUTO:
              newSettings = {
                theme: THEMES.DEFAULT,
                lightMode: LIGHT_MODE.LIGHT
              }
              break;
            case LIGHT_MODE.LIGHT:
              newSettings = {
                theme: THEMES.DARK,
                lightMode: LIGHT_MODE.DARK
              }
              break;
            case LIGHT_MODE.DARK:
              newSettings = {
                theme: window.matchMedia('(prefers-color-scheme: dark)').matches ? THEMES.DARK : THEMES.DEFAULT,
                lightMode: LIGHT_MODE.AUTO
              }
              break;
            default:
              break;
          }
          saveSettings(newSettings)
        }}
      >
        {settings.lightMode == LIGHT_MODE.AUTO && <IconAuto />}
        {settings.lightMode == LIGHT_MODE.LIGHT && <IconLigth />}
        {settings.lightMode == LIGHT_MODE.DARK && <IconDark />}
      </IconButton>
    </Tooltip>
  );
};

export default ChangeTheme;
